<style scoped lang="sass">
.extra-link
  text-align: center
  padding: 1rem 0.5rem
</style>
<template>
  <div>
    <form @submit.prevent="attemptLogin">
      <!-- fake fields are a workaround for chrome autofill getting the wrong fields -->
      <input style="display:none" type="text" name="usernamefakeout"/>
      <input style="display:none" type="password" name="passwordfakeout"/>
      <div v-if="message">{{message}}</div>
      <div v-if="errors.length">
        <div v-for="(error,i) in errors" :key="i">{{error}}</div>
      </div>
      <div class="input-group">
        <label>EMAIL</label>
        <input type="email" placeholder="Email" v-model="login.email" class="input-control">
      </div>
      <div class="input-group">
        <label>PASSWORD</label>
        <input type="password" placeholder="Password" v-model="login.password" class="input-control">
      </div>
      <div>
        <input type="submit" value="Login" class="button positive">
      </div>
    </form>
    <div class="extra-link">
      <router-link :to="{name: 'passwordReset', params: {email: login.email}}">Forgot your password?</router-link>
    </div>
  </div>
</template>
<script>
export default {
  name: 'login',
  props: {
  },
  data() {
    return {
      errors: [],
      message: null,
      login: {
        email: null,
        password: ''
      }
    };
  },
  created() {
    this.message = this.$store.getters['messages/getMessage']({key: 'loginMessage'});
    this.$store.dispatch('messages/clearMessage', {key: 'loginMessage'});
    this.login.email = this.$store.getters['messages/getMessage']({key: 'loginEmail'});
    this.$store.dispatch('messages/clearMessage', {key: 'loginEmail'});
  },
  methods: {
    attemptLogin: function() {
      this.$store.dispatch('logIn', this.login)
        .then(() => this.$router.push({name: 'dashboard'}))
        .catch(({response: {data: {errors}}}) => {
          this.errors = errors;
        });
    }
  }
};
</script>
